import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { portfolioService } from "../services/portfolio.service";

export const createPortfolio = createAsyncThunk("createPortfolio", async (data, { rejectWithValue }) => {
     try {
        return await portfolioService.createPortfolio(data);
     } catch (error) {
        if (!error.response) {
            throw error;
        }
        return rejectWithValue(error.response.data);
     }
});

export const getPortfolioList = createAsyncThunk("getPortfolioList", async (params, { rejectWithValue }) => {
    try {
        //if status =="", then remove it
        if(params.status === ""){
            delete params.status;
        }
        return await portfolioService.getPortfolioList(params);
    } catch (error) {
        if (!error.response) {
            throw error;
        }
        return rejectWithValue(error.response.data);
    }
});

export const getPortfolio = createAsyncThunk("getPortfolio", async (id, { rejectWithValue }) => {
    try {
        return await portfolioService.getPortfolio(id);
    } catch (error) {
        if (!error.response) {
            throw error;
        }
        return rejectWithValue(error.response.data);
    }
});

export const updatePortfolio = createAsyncThunk("updatePortfolio", async ({data,id}, { rejectWithValue }) => {
    try {
        return await portfolioService.updatePortfolio(id, data);
    } catch (error) {
        if (!error.response) {
            throw error;
        }
        return rejectWithValue(error.response.data);
    }
});

export const deletePortfolio = createAsyncThunk("deletePortfolio", async (id, { rejectWithValue }) => {
    try {
        return await portfolioService.deletePortfolio(id);
    } catch (error) {
        if (!error.response) {
            throw error;
        }
        return rejectWithValue(error.response.data);
    }
});

export const updatePortfolioStatus = createAsyncThunk("updatePortfolioStatus", async (data, { rejectWithValue }) => {
    try {
        return await portfolioService.updatePortfolioStatus(data);
    } catch (error) {
        if (!error.response) {
            throw error;
        }
        return rejectWithValue(error.response.data);
    }
});


const portfolioSlice = createSlice({
    name: "pmo-portfolio",
    initialState: {
        list:{
          data: null,
          isLoading: false,
          isError: false,
          message: null,
        },
        detail:{
          data: null,
          isLoading: false,
          isError: false,
          message: null,
        },
        create:{
          data: null,
          isLoading: false,
          isError: false,
          message: null,
        },
        update:{
          data: null,
          isLoading: false,
          isError: false,
          message: null,
        },
        delete:{
          data: null,
          isLoading: false,
          isError: false,
          message: null,
        },
        status:{
          data: null,
          isLoading: false,
          isError: false,
          message: null,
        },
    },
    reducers: {
		resetStatePortfolio: (state) => {
			state.list.isError = false;
			state.list.message = null;
			state.detail.isError = false;
			state.detail.message = null;
			state.create.isError = false;
			state.create.message = null;
			state.create.data = null;
			state.update.isError = false;
			state.update.message = null;
			state.update.data = null;
			state.delete.isError = false;
			state.delete.message = null;
			state.delete.data = null;
			state.status.isError = false;
			state.status.message = null;
			state.status.data = null;
		},
	},
    extraReducers: (builder) => {

        // get portfolio list
        builder.addCase(getPortfolioList.pending, (state) => {
            state.list.isLoading = true;
        });
        builder.addCase(getPortfolioList.fulfilled, (state, action) => {
            state.list.isLoading = false;
            state.list.data = action.payload;
            state.list.isError = false;
        });
        builder.addCase(getPortfolioList.rejected, (state, action) => {
            state.list.isLoading = false;
            state.list.isError = true;
            state.list.message = '';
        });

        // get portfolio
        builder.addCase(getPortfolio.pending, (state) => {
            state.detail.isLoading = true;
        });
        builder.addCase(getPortfolio.fulfilled, (state, action) => {
            state.detail.isLoading = false;
            state.detail.data = action.payload;
            state.detail.isError = false;
        });
        builder.addCase(getPortfolio.rejected, (state, action) => {
            state.detail.isLoading = false;
            state.detail.isError = true;
            state.detail.message = action.payload.message;
        });

        // create portfolio

        builder.addCase(createPortfolio.pending, (state) => {
            state.create.isLoading = true;
        });
        builder.addCase(createPortfolio.fulfilled, (state, action) => {
            state.create.isLoading = false;
            state.create.data = action.payload;
            state.create.isError = false;
        });
        builder.addCase(createPortfolio.rejected, (state, action) => {
            state.create.isLoading = false;
            state.create.isError = true;
            state.create.message = action.payload.message;
        });

        // update portfolio

        builder.addCase(updatePortfolio.pending, (state) => {
            state.update.isLoading = true;
        });
        builder.addCase(updatePortfolio.fulfilled, (state, action) => {
            state.update.isLoading = false;
            state.update.data = action.payload;
            state.update.isError = false;
        });
        builder.addCase(updatePortfolio.rejected, (state, action) => {
            state.update.isLoading = false;
            state.update.isError = true;
            state.update.message = action.payload.message;
        });

        // delete portfolio

        builder.addCase(deletePortfolio.pending, (state) => {
            state.delete.isLoading = true;
        });
        builder.addCase(deletePortfolio.fulfilled, (state, action) => {
            state.delete.isLoading = false;
            state.delete.data = action.payload;
            state.delete.isError = false;
        });
        builder.addCase(deletePortfolio.rejected, (state, action) => {
            state.delete.isLoading = false;
            state.delete.isError = true;
            state.delete.message = action.payload.message;
        });

        // update portfolio status

        builder.addCase(updatePortfolioStatus.pending, (state) => {
            state.status.isLoading = true;
        });
        builder.addCase(updatePortfolioStatus.fulfilled, (state, action) => {
            state.status.isLoading = false;
            state.status.data = action.payload;
            state.status.isError = false;
        });
        builder.addCase(updatePortfolioStatus.rejected, (state, action) => {
            state.status.isLoading = false;
            state.status.isError = true;
            state.status.message = action.payload.message;
        });

    },
});

export default portfolioSlice.reducer;
export const { resetStatePortfolio } = portfolioSlice.actions;